<button [type]="type()" class="button" [ngClass]="cssClasses()" [disabled]="disabled() || loading()">
  @if (icon(); as icon) {
    <ui-inline-svg [name]="icon" class="icon"></ui-inline-svg>
  }
  <ng-content></ng-content>
  @if (loading()) {
    <ui-inline-svg name="loading" class="loading-icon"></ui-inline-svg>
  }
</button>
